const ERROR_MESSAGE_CHROME = 'Failed to fetch';
const ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const ERROR_MESSAGE_OTHER = 'Network request failed';

const NetworkErrorMessages = new Set<string>([
	ERROR_MESSAGE_CHROME,
	ERROR_MESSAGE_FIREFOX,
	ERROR_MESSAGE_OTHER,
]);

export const isNetworkError = (error: Error) =>
	typeof error === 'object' &&
	NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));
